"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Address = _interopRequireDefault(require("./Address"));
var _PaymentCardDetails = _interopRequireDefault(require("./PaymentCardDetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The DebitCard model module.
 * @module model/DebitCard
 * @version 3.0
 */
var DebitCard = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>DebitCard</code>.
   * @alias module:model/DebitCard
   */
  function DebitCard() {
    _classCallCheck(this, DebitCard);
    DebitCard.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(DebitCard, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>DebitCard</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DebitCard} obj Optional instance to populate.
     * @return {module:model/DebitCard} The populated <code>DebitCard</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new DebitCard();
        if (data.hasOwnProperty('paymentId')) {
          obj['paymentId'] = _ApiClient["default"].convertToType(data['paymentId'], 'Number');
        }
        if (data.hasOwnProperty('basketId')) {
          obj['basketId'] = _ApiClient["default"].convertToType(data['basketId'], 'Number');
        }
        if (data.hasOwnProperty('amount')) {
          obj['amount'] = _ApiClient["default"].convertToType(data['amount'], 'Number');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('gateway')) {
          obj['gateway'] = _ApiClient["default"].convertToType(data['gateway'], 'String');
        }
        if (data.hasOwnProperty('confirmedBasketHash')) {
          obj['confirmedBasketHash'] = _ApiClient["default"].convertToType(data['confirmedBasketHash'], 'String');
        }
        if (data.hasOwnProperty('reference')) {
          obj['reference'] = _ApiClient["default"].convertToType(data['reference'], 'String');
        }
        if (data.hasOwnProperty('cardDetails')) {
          obj['cardDetails'] = _PaymentCardDetails["default"].constructFromObject(data['cardDetails']);
        }
        if (data.hasOwnProperty('billingAddress')) {
          obj['billingAddress'] = _Address["default"].constructFromObject(data['billingAddress']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DebitCard</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DebitCard</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['gateway'] && !(typeof data['gateway'] === 'string' || data['gateway'] instanceof String)) {
        throw new Error("Expected the field `gateway` to be a primitive type in the JSON string but got " + data['gateway']);
      }
      // ensure the json data is a string
      if (data['confirmedBasketHash'] && !(typeof data['confirmedBasketHash'] === 'string' || data['confirmedBasketHash'] instanceof String)) {
        throw new Error("Expected the field `confirmedBasketHash` to be a primitive type in the JSON string but got " + data['confirmedBasketHash']);
      }
      // ensure the json data is a string
      if (data['reference'] && !(typeof data['reference'] === 'string' || data['reference'] instanceof String)) {
        throw new Error("Expected the field `reference` to be a primitive type in the JSON string but got " + data['reference']);
      }
      // validate the optional field `cardDetails`
      if (data['cardDetails']) {
        // data not null
        _PaymentCardDetails["default"].validateJSON(data['cardDetails']);
      }
      // validate the optional field `billingAddress`
      if (data['billingAddress']) {
        // data not null
        _Address["default"].validateJSON(data['billingAddress']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} paymentId
 */
DebitCard.prototype['paymentId'] = undefined;

/**
 * @member {Number} basketId
 */
DebitCard.prototype['basketId'] = undefined;

/**
 * @member {Number} amount
 */
DebitCard.prototype['amount'] = undefined;

/**
 * @member {String} currency
 */
DebitCard.prototype['currency'] = undefined;

/**
 * @member {String} gateway
 */
DebitCard.prototype['gateway'] = undefined;

/**
 * @member {String} confirmedBasketHash
 */
DebitCard.prototype['confirmedBasketHash'] = undefined;

/**
 * @member {String} reference
 */
DebitCard.prototype['reference'] = undefined;

/**
 * @member {module:model/PaymentCardDetails} cardDetails
 */
DebitCard.prototype['cardDetails'] = undefined;

/**
 * @member {module:model/Address} billingAddress
 */
DebitCard.prototype['billingAddress'] = undefined;
var _default = exports["default"] = DebitCard;